import styled from 'styled-components';
export const StyledUL = styled.ul `
  &&& {
    margin: 0;
    padding: 0;
    list-style: none;
    height: 100%;
  }
`;
